import React from "react";
import { useNavigate } from "react-router-dom";

function VideoCreateDemoPage() {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/video-shorts");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999999,
        overflow: "hidden",
        background:
          "radial-gradient(circle at top right, rgba(0,242,255,0.25), transparent 30%), #03070d",
        color: "#fff",
        fontFamily: "Arial",
      }}
    >
      <style>
        {`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }

          @keyframes recordPulse {
            0%,100% { transform: scale(1); }
            50% { transform: scale(1.15); }
          }

          @keyframes timelineFill {
            0% { width: 0%; }
            100% { width: 100%; }
          }

          @keyframes buttonGlow {
            0%,100% { box-shadow: 0 0 10px #00f2ff; }
            50% { box-shadow: 0 0 25px #00f2ff; }
          }
        `}
      </style>

      {/* 🔙 RETOUR */}
      <button
        onClick={goBack}
        style={{
          position: "fixed",
          top: 20,
          left: 20,
          padding: "10px 16px",
          borderRadius: 12,
          border: "1px solid #00f2ff",
          background: "transparent",
          color: "#00f2ff",
          fontWeight: "bold",
          zIndex: 9999999,
        }}
      >
        ← Retour
      </button>

      {/* CONTENU */}
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <h1 style={{ fontSize: 40, marginBottom: 10, animation: "fadeUp 0.6s" }}>
          🎬 Création rapide
        </h1>

        <p style={{ color: "#9befff", marginBottom: 30 }}>
          Filmer, éditer et publier en quelques secondes.
        </p>

        {/* 📱 TÉLÉPHONE */}
        <div
          style={{
            width: 320,
            height: 580,
            borderRadius: 30,
            border: "1px solid #00f2ff",
            position: "relative",
            overflow: "hidden",
            background: "#000",
          }}
        >
          {/* 🔥 LOGO EVO EN FOND */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              opacity: 0.08,
              fontSize: 120,
              fontWeight: "bold",
            }}
          >
            EVO
          </div>

          {/* 🎥 overlay */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(180deg, rgba(0,242,255,0.15), rgba(0,0,0,0.9))",
            }}
          />

          {/* 🎬 timeline */}
          <div
            style={{
              position: "absolute",
              bottom: 170,
              left: 20,
              right: 20,
              height: 6,
              borderRadius: 10,
              background: "rgba(255,255,255,0.1)",
            }}
          >
            <div
              style={{
                height: "100%",
                background: "#00f2ff",
                animation: "timelineFill 3s linear infinite",
              }}
            />
          </div>

          {/* 🔴 BOUTON RECORD */}
          <div
            style={{
              position: "absolute",
              bottom: 90,
              left: "50%",
              transform: "translateX(-50%)",
              width: 70,
              height: 70,
              borderRadius: "50%",
              background: "#ff0055",
              animation: "recordPulse 1.2s infinite",
            }}
          />

          {/* ✨ BOUTONS PROPRES (PLUS DE ROND CHELOU) */}
          <div
            style={{
              position: "absolute",
              right: 12,
              top: 100,
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
          >
            {[
              { icon: "✨", label: "Effet" },
              { icon: "🎨", label: "Filtre" },
              { icon: "🎵", label: "Son" },
            ].map((btn, i) => (
              <div
                key={i}
                style={{
                  width: 50,
                  height: 50,
                  borderRadius: 14,
                  background: "rgba(0,0,0,0.6)",
                  border: "1px solid #00f2ff",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 16,
                }}
              >
                <div>{btn.icon}</div>
              </div>
            ))}
          </div>

          {/* 🚀 BOUTON PUBLIER */}
          <div
            style={{
              position: "absolute",
              bottom: 20,
              right: 20,
              padding: "10px 16px",
              borderRadius: 14,
              background: "#00f2ff",
              color: "#000",
              fontWeight: "bold",
              animation: "buttonGlow 1.5s infinite",
            }}
          >
            Publier 🚀
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoCreateDemoPage;